export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-rewind-15497c46de51998a6b24be13b3f883eb.svg";